import { FormCard, FormItem, TextArea } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

export const PersonalNotesFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  return (
    <FormCard
      title={t(supConstants.PERSONAL_NOTES)}
      subtitle={t(supConstants.PERSONAL_NOTES_DESC)}
    >
      <FormItem name="summary">
        <TextArea
          autoSize={{
            minRows: 3
          }}
        />
      </FormItem>
    </FormCard>
  )
}
